import React from 'react';
import { motion } from 'framer-motion';

const SpinnerLoader = function SpinnerLoader() {
  const spinnerVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 1,
        repeat: Infinity,
        ease: 'linear',
      },
    },
  };

  const spinnerStyles = {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    border: '4px solid rgba(249, 113, 113, 0.2)',
    borderTop: '4px solid rgba(249, 113, 113, 1)',
    borderRadius: '50%',
  };

  return (
    <div className="flex gap-2 flex-col items-center">
      <motion.div
        style={spinnerStyles}
        variants={spinnerVariants}
        initial="initial"
        animate="animate"
      />
    </div>
  );
};

SpinnerLoader.defaultProps = {
};

export default SpinnerLoader;
